<div
  class="d-block-inline"
  #ref
  [hideOnClick]="false"
  [html]="true"
  [portalTippy]="
    copyIcon + ((copied ? 'common.copyToClipboard.success' : 'common.copyToClipboard') | translate)
  "
  (click)="copyToClipboard($event)"
  (mouseleave)="mouseLeft($event)"
  appendTo="parent"
>
  <ng-content></ng-content>
</div>
@if (ref.children.length === 0) {
  <portal-icon-button
    [hideOnClick]="false"
    [portalTippy]="(copied ? 'common.copyToClipboard.success' : 'common.copyToClipboard') | translate"
    [preventAndStop]="true"
    (hidden)="copied = false"
    (onClick)="copyToClipboard($event)"
    appendTo="body"
    iconClass="far fa-copy ms-1"
  >
  </portal-icon-button>
}
